import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import Loading from './Loading';

const DEFAULT_ROOT_MARGIN = '200px 0px 0px 0px';

export default function InfiniteLoadingTrigger({
  loading,
  done,
  onEnter,
  root,
  rootMargin = DEFAULT_ROOT_MARGIN,
}: {
  loading: boolean;
  done: boolean;
  onEnter: () => void;
  root?: Element | null;
  rootMargin?: string;
}) {
  const { ref, inView } = useInView({
    threshold: 0.1,
    root: root ?? undefined,
    rootMargin,
  });

  useEffect(() => {
    if (!loading && inView && !done) {
      onEnter();
    }
  }, [loading, inView, onEnter, done]);

  if (done) return null;
  return (
    <div
      ref={ref}
      className={`bg-gray-30 dark:bg-gray-75 flex h-10 w-16 items-center justify-center rounded-lg transition-opacity ${
        loading ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <Loading />
    </div>
  );
}
